import axios from "../configRequest";
import { I_AXIOS } from "../configRequest.model";

interface I_CREATE_APPLICATION_PAYLOAD {
    ex_id: string;
    locale: string;
    location: string;
    device_id: string;
    source: string;
    imei: string;
    company_name?: string;
    contact_person?: {
        address: string;
        first_name: string;
        last_name: string;
        city_name: string;
        phone: string;
        email: string;
    };
    pickup_date?: string;
    first_name?: string;
    last_name?: string;
    email: string;
    phone: string;
    city_name?: string;
    address?: string;
    brand?: string;
    model?: string;
    price?: number;
    grade?: string;
    top_up_model?: string;
    top_up_price?: number;
    trade_up_price?: number;
    trade_up_devices?: string;
    session?: string;
}

interface I_CREATE_APPLICATION_RESPONSE {
    status: 0 | 1;
    data: {
        application_id: number;
    };
    errors: {
        [key: string]: string[];
    };
    message: string;
}

export async function createApplication(payload: I_CREATE_APPLICATION_PAYLOAD) {
    const contractData = await axios.post<I_CREATE_APPLICATION_RESPONSE>(
        `${I_AXIOS.TI_API}/api/plvoucher`,
        payload,
    );
    return contractData.data;
}

export default createApplication;
